import { IQuery, Topics } from '@zaplify/common';

interface IProspectOrganization {
    organizationId: string;
    organizationDomain: string;
    organizationLinkedinUrl?: string;
    organizationIndustry: string;
    organizationName: string;
    organizationSize: string;
}

export class GetPplCompanyQuery extends IQuery<IProspectOrganization | undefined> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly searchFields: { companyName?: string; website?: string }) {
        super();
    }
}
